import { render } from "./SettingsNon.vue?vue&type=template&id=b128412c&scoped=true&ts=true"
import script from "./SettingsNon.vue?vue&type=script&lang=ts"
export * from "./SettingsNon.vue?vue&type=script&lang=ts"

import "./SettingsNon.vue?vue&type=style&index=0&id=b128412c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b128412c"]])

export default __exports__